import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import PaymentIcon from '@material-ui/icons/Payment';
import { useCustomerDetailsStyles } from './CustomerDetails';

const PaymentRow = ({ customer }) => {
  const classes = useCustomerDetailsStyles();
  const {
    cc_brand = 'N/A',
    cc_last4 = 'N/A',
    stripe_customer_id,
    square_customer_id,
  } = customer || {};
  return (
    <Grid item>
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        <Grid item xs={1} className={classes.cardIcon}>
          <PaymentIcon fontSize="large" />
        </Grid>
        <Grid item xs className={classes.cardTextContent}>
          <Typography className={classes.fw500}>
            {cc_brand} •••• {cc_last4}
          </Typography>
          {stripe_customer_id && (
            <Typography>Stripe Customer ID: {stripe_customer_id}</Typography>
          )}
          {square_customer_id && (
            <Link
              target="blank"
              variant="body1"
              href={`https://squareup.com/dashboard/customers/directory/customer/${square_customer_id}`}
            >
              View in Square
            </Link>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PaymentRow;
